module.exports = __webpack_public_path__ + "static/WEDDING E&M-134-579790f60587a6dcbe6fc4401f121bf7.jpg";